import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { IDynamicSimpleText } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { createInstanceWithChildren } from '../../../utils/dynamic-items-utils';
import { ProductsOnTheWayDataType } from '../../tenants/common/products-on-the-way/products-on-the-way-helpers';
import { onClickEventHandlers } from './on-click-event-handlers';

const deliveryDate: IDynamicSimpleText = {
  contentTypeId: 'dynamic-elements-simple-text',
  inputs: {
    text: {
      values: [
        {
          provider: 'parent',
          property: 'itemData',
        },
        {
          provider: 'id:root',
          property: 'showOrdinalSuffix',
        },
      ],
      transform: function ([productData, showOrdinalSuffix]: [
        ProductsOnTheWayDataType,
        boolean,
      ]): string {
        const getMonthAbbr = (date: Date) => {
          const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ];
          return monthNames[date.getMonth()];
        };

        const nextDeliveryDate = new Date(
          productData.deliveryDate.substring(0, 10),
        );

        const monthAbbr = getMonthAbbr(nextDeliveryDate);
        const dayInMonth = nextDeliveryDate.getDate();
        const ordinalSuffix = showOrdinalSuffix
          ? window.neoclesDynamicFramework.recommendationsPanels.methods.getNumberOrdinalSuffix(
              dayInMonth,
            )
          : '';

        const deliveryDateStr =
          `${monthAbbr} ${dayInMonth}${ordinalSuffix}`.toUpperCase();
        return deliveryDateStr;
      }.toString(),
    },
  },
  eventHandlers: {
    onClick: onClickEventHandlers,
  },
};

export const deliveryDateContainer = createInstanceWithChildren({
  styles: {
    style: {
      color: 'black',
      top: '0px',
      right: '0px',
      'font-size': '1.2rem',
    },
    classes: [
      'position-absolute',
      'mr-1',
      'd-flex',
      'flex-row',
      'cursor-pointer',
    ],
  },
  contentTypeId: 'dynamic-collections-renderer',
  children: [deliveryDate],
  attributes: {
    title: recommendationsPanelsLocaleKeys.requestedDeliveryDate,
  },
  eventHandlers: {
    onClick: onClickEventHandlers,
  },
});
